export default __webpack_public_path__ + "8c2cc176fa2b72804cbf2d6bcc1c7af2.png";